import { useEffect, useRef } from "react";
import Navigation from "@/components/Navigation";
import HeroSection from "@/components/HeroSection";
import ClientsSection from "@/components/ClientsSection";
import ServicesSection from "@/components/ServicesSection";
import SoftwareShowcaseSection from "@/components/SoftwareShowcaseSection";
import AboutSection from "@/components/AboutSection";
import SchedulerSection from "@/components/SchedulerSection";
import TestimonialsSection from "@/components/TestimonialsSection";
import SocialFeedSection from "@/components/SocialFeedSection";
import CaseStudiesSection from "@/components/CaseStudiesSection";
import BlogSection from "@/components/BlogSection";
import NewsletterSection from "@/components/NewsletterSection";
import NewsletterSignupSection from "@/components/NewsletterSignupSection";
import ROITeaserSection from "@/components/ROITeaserSection";
import Footer from "@/components/Footer";
import { usePageTracking, useSectionTracking } from "@/hooks/useTracking";
import { useSeo } from "@/hooks/useSeo";

const TrackedSection = ({ id, children }) => {
  const ref = useRef(null);
  useSectionTracking(id, ref);
  return <div ref={ref} id={`section-${id}`}>{children}</div>;
};

export default function LandingPage() {
  usePageTracking("/");
  useSeo();

  useEffect(() => {
    document.documentElement.style.scrollBehavior = 'smooth';
    return () => { document.documentElement.style.scrollBehavior = 'auto'; };
  }, []);

  return (
    <div className="min-h-screen bg-lab-bg-light" data-testid="landing-page">
      <Navigation />
      <main>
        <TrackedSection id="hero"><HeroSection /></TrackedSection>
        <TrackedSection id="services"><ServicesSection /></TrackedSection>
        <TrackedSection id="roi"><ROITeaserSection /></TrackedSection>
        <TrackedSection id="software"><SoftwareShowcaseSection /></TrackedSection>
        <TrackedSection id="about"><AboutSection /></TrackedSection>
        <TrackedSection id="scheduler"><SchedulerSection /></TrackedSection>
        <TrackedSection id="testimonials"><TestimonialsSection /></TrackedSection>
        <TrackedSection id="clients"><ClientsSection /></TrackedSection>
        <SocialFeedSection />
        <TrackedSection id="case-studies"><CaseStudiesSection /></TrackedSection>
        <TrackedSection id="blog"><BlogSection /></TrackedSection>
        <TrackedSection id="newsletter"><NewsletterSection /></TrackedSection>
        <NewsletterSignupSection />
      </main>
      <Footer />
    </div>
  );
}
